import { PropType } from 'vue'

export const gImagePorps = {
  appendToBody: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  hideOnClickModal: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  src: {
    type: String as PropType<string>,
    default: ''
  },
  className: {
    type: String as PropType<string>,
    default: ''
  },
  fit: {
    type: String as PropType<string>,
    default: 'contain'
  },
  lazy: Boolean,
  alt: {
    type: String as PropType<string>,
    default: `People's Daily English language App - Homepage - Breaking News, China News, World News and Video`
  },
  scrollContainer: {
    type: [String, Object] as PropType<any>,
  },
  placeholder: {
    type: [ Function, Object ] as PropType<any>,
    default: () => undefined
  },
  fallback: {
    type: [ Function, Object ] as PropType<any>,
    default: () => undefined
  },
  onError: {
    type: Function as PropType<(e: Error) => void>
  },
  onClick: {
    type: Function as PropType<(info: any) => void>
  },
  disablePreview: Boolean,
  previewSrcList: {
    type: Array as PropType<string[]>,
    default: () => [] as string[]
  },
  width: Number,
  height: Number,
  zIndex: {
    type: Number as PropType<number>,
    default: 2000
  }
}

export const gImageViewProps = {
  urlList: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  zIndex: gImagePorps.zIndex,
  initialIndex: {
    type: Number as PropType<number>,
    default: 0
  },
  infinite: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  onHideOnClickModal: gImagePorps.hideOnClickModal
}
